<div id="user-reached-the-apply-limit">
  <div class="db-error-section">
    <div class="user-apply-limit">
    <!-- <p *ngIf="isLanguageJapanese">ご応募ありがとうございます。</p> -->
      <p>{{'ERROR.REGISTER_REACHED_MAXIMUM_NUMBER'|translate}}</p>
    </div>
  </div>
</div>
